import { instruments } from 'components/constants';

interface SelectPMBMProps {
    selectedAllMetals: DefaultMetals;
    setSelectedAllMetals: (value: DefaultMetals) => void;
}

function SelectPMBM({
    selectedAllMetals,
    setSelectedAllMetals,
}: SelectPMBMProps) {

  const renderInstrumentOptions = () => {
    const groupedInstruments = {
      'Precious Metals': instruments.filter((i) => i.apiType === 'precious'),
      'Base Metals': instruments.filter((i) => i.apiType === 'base'),
    };

    return (
      <>
        {Object.entries(groupedInstruments).map(([group, groupInstruments]) => (
          <optgroup label={group} key={group}>
            {groupInstruments.map((instrument) => (
              <option key={instrument.id} value={instrument.id}>
                {instrument.name}
              </option>
            ))}
          </optgroup>
        ))}
      </>
    );
  };


  return (
    <div>
      <select
        value={selectedAllMetals}
        onChange={(e) => {
          setSelectedAllMetals(e.target.value as DefaultMetals);
        }}
        className='mr-2 lg:mr-2 p-1 my-2 text-[14px] rounded border bg-white dark:bg-gray-700 text-gray-900 dark:text-white h-[32px]'
      >
        {renderInstrumentOptions()}
      </select>
    </div>
  );
}

export default SelectPMBM;